import React from "react";
import HistoricLineChart from "./HistoricLineChart";
import { parseNumber } from "src/lib/historyChart";

export default function HistoricTemperatures(props) {
  return (
    <HistoricLineChart
      title="Temperature Historic Graph"
      subject="temperature"
      history={props.historicTemperatures}
      parse={parseNumber}
      kind="numeric"
      unit="°C"
      yLabel="Temperature (°C)"
      startDate={props.startDate}
      endDate={props.endDate}
    />
  );
}
